import Vue from 'vue'

const truncateEmail = (email: string, prefixLength = 18, suffixLength = 13) => {
  if (email) {
    const emails = email.split('@')
    if (emails.length > 0) {
      const prefix = Vue.prototype.truncate(emails[0], prefixLength)
      const suffix = emails.length > 1 ? Vue.prototype.truncate(emails[1], suffixLength) : ''
      return `${prefix}@${suffix}`
    }
  }
  return ''
}

export function getTextReadableTime(text: string, noticeTime: number = 1000) {
  // A word
  const tokens = text.split(' ')

  // Base word milliseconds to read.
  // Which means that an average word of AverageComplexity characters will take 480 ms to read.
  const timePerToken = 230

  // Average word complexity, basically the amount of characters a word might have in average.
  const averageTokenComplexity = 4

  // The final and total time in milliseconds the given text will probably be taken to be read.
  let time = 0

  tokens.forEach((token) => {
    const tokenComplexity = token.length
    
    // We increase or decrease the time per token if its complexity is bigger or lower than 4.
    time += timePerToken * ( tokenComplexity / averageTokenComplexity )
  })

  return time + noticeTime
}

export default {
  truncateEmail
}